import { useState, Fragment, useEffect, useCallback } from "react";
import { Button } from "core/components/form-controls";
import BottomSwiper from "core/components/BottomSwiper";
import { _t } from "core/language";
import Icon from 'core/assets/icons';
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName } from "core/router";
import { useResetAiChef } from "./../../hooks/aiChef";
import { CImagePicker } from "core/components/form-controls";
import { useGetImagePicker } from "core/hooks/useImagePicker";
import { ImageTypeEnums, OpenImagePickerType } from "core/store/upload/actions";

const SelectSwiper = ({setIsDrawerOpen, toggleDrawer, type = 'aiChefImageIngredient'}: any) => {
  const navigate = useCustomNavigate()
  const { onReset } = useResetAiChef()
  const aiChefImageIngredient = useGetImagePicker(
    type,
    false
  )
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const onOpen = () => setIsOpen(true);
  const onClose = () => {
    setIsOpen(false);
    setTimeout(() => {
      setIsDrawerOpen(false);
    }, 300)
  }


  useEffect(() => {
    onOpen()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const _toggleDrawer = useCallback(() => {
    setIsOpen((prevState: boolean) => !prevState);
    toggleDrawer();
  }, [toggleDrawer]);

  const goToAI = useCallback(() => {
    onReset()
    // console.log('go to', RouterName.AI_CHEF_LOADING)
    onClose()
    if(type && type === 'aiChefImageIngredient'){
      navigate(RouterName.AI_CHEF_INGREDIENT_LOADING)
    }
    
  }, [])

  useEffect(() => {
    // has new image and image is uploading
    // go to AI analysis image
    if (aiChefImageIngredient && aiChefImageIngredient.uploading) {
      goToAI();
    }
  }, [aiChefImageIngredient, goToAI])

  return (
    <Fragment>
      
      <BottomSwiper
        isOpen={isOpen}
        toggleDrawer={_toggleDrawer}
        zIndex={50}
      >
        <div className="flex flex-col gap-3">
          <CImagePicker
            name={type}
            property={ImageTypeEnums.TEMPORARY}
            openType={OpenImagePickerType.CAMERA}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('aiChef.add_image_by_camera')}
                classBtn="w-full"
                primary
                icon={Icon.RecipeSelectImageByCamera}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
          />

          <CImagePicker
            name={type}
            property={ImageTypeEnums.TEMPORARY}
            openType={OpenImagePickerType.GALLERY}
            hideRemoveIcon
            component={{
              input: <Button
                label={_t('aiChef.add_image_by_gallery')}
                classBtn="w-full"
                primary
                outline
                icon={Icon.RecipeSelectImageByGallery}
              />,
              loading: <div></div>,
              preview: () => 
                <div></div>
            }}
          />
        </div>
      </BottomSwiper>
    </Fragment>
  )
}

export default SelectSwiper
